import React from 'react'
import setUp from "../../images/setUp.png"
import { Link } from 'react-router-dom';
import { useState } from 'react';
import uniswap from "../../images/uniswap.png"
import Screenshot from "../../images/Screenshot.png"
import monitor from "../../images/monitor.png"
import CloseCarbon_logo2 from "../../images/CloseCarbon_logo2.png"

function Plans() {
  const [activeTab, setActiveTab] = useState(0);

  const plans = [
    {
      name: 'Governance',
      price: '0',
      tag: "Free",
      title: 'CloseCarbon Governance',
      link: "/plans/governance",
      description: [
'Nationally Determined Contributions (NDC) Programs ',
'Government organizations',
'Large Private Institutions'
      ],
      features: [
        'Real-time tracking of NDC performance and sustainability targets ',
        'Independent validation of climate projects ',
        'Third-party verification of emissions data ',
        'Standard-aligned compliance framework ',
        'Issuance of CloseCarbon Reduction Tonnes (CCRTs) for verified reductions ',
        'Transparent oversight and reporting tools '
      ],
    },
    {
      name: 'Basic',
      price: '0',
      tag: "Free",
      title: 'CloseCarbon Basic',
      link: "/plans/basic",
      description: [
        'Renewable Energy Projects ',
        'Infrastructure Transition & Monitoring Projects',
      ],
      features: [
        'Project validation aligned with recognized standards ',
        'Verification of carbon reduction data ',
        'Issuance of CloseCarbon Reduction Tonnes (CCRTs) ',
        'Real-time carbon monitoring dashboard',
        'Structured emissions reporting',
        'Clear, traceable proof of emissions reduction '
      ],
    },
    {
      name: 'Business',
      price: '15,995',
      tag: "Monthly",
      title: 'CloseCarbon Business',
      link: "/plans/business",
      description: ['Gather Insights on Carbon emission data'],
      features: [
        'Real-time carbon emissions monitoring ',
        'Comprehensive carbon emissions reports',
        'Carbon Monitoring Certificate ',
        'Issuance of CloseCarbon Reduction Tonnes (CCRTs) ',
        'Optional review by Regional Oversight and Sub-CCVs (Non-Accredited Endorsing Bodies) for enhanced credibility ',
        'Verified documentation for sustainability reporting '
      ],
    },
    {
      name: 'Verifiers',
      tag: "Free",
      price: '0',
      title: 'CloseCarbon Verifiers',
      link: "/plans/verifier",
      description: ['Whether you\'re a beginner in your career or you\'re already an established verifier, this plan offers a pivotal role in ensuring the accuracy and integrity of emission data.',],
      features: [
        'Verification of project emissions and reductions ',
        'Structured data review tools ',
        'Compliance-based assessment framework ',
        'Standard-aligned verification workflow',
        'Reporting and approval documentation tools '
      ],
    },
    {
      name: 'Business Plus',
      link: "/plans/business-plus",
      price: '19,995',
      tag: "Monthly",
      title: 'CloseCarbon BusinessPlus',
      description: ['Decentralized Peer-to-Peer Energy Trading ', 'Blockchain-Based Smart Contracts',],
      features: [
        'Real-time energy production and consumption tracking for decision-making ',
        'Secure marketplace for surplus renewable energy trading ',
        'Smart contract enabled transactions ',
        'Energy efficiency analytics and optimization tools ',
        'Carbon emissions reporting and certification ',
        'Issuance of CloseCarbon Reduction Tonnes (CCRTs) ',
        'Integrated monitoring of energy and carbon performance'
      ],
    },
  ];

  const currentPlan = plans[activeTab];

  const cards = [
    {
      id: 1,
      image: setUp,
      title: "Set up your wallet for polygon",
      bullets: [
        "Configure polygon network",
        "Ensure you have MATIC",
      ],
      imageLabel: "Screenshot 1",
    },
    {
      id: 2,
      image: uniswap,
      title: "Access the uniswap interface",
      bullets: [
        "Visit the uniswap website ",
        "Connect your wallet",
        "Switch to the polygon network",
      ],
      imageLabel: "Group 1272628377",
    },
    {
      id: 3,
      image: Screenshot,
      title: "Prepare for swap and execute swap",
      bullets: [
        "Token approval",
        "Set up the trade",
      ],
      imageLabel: "Frame 1618873100",
    },
    {
      id: 4,
      image: monitor,
      title: "Monitor transaction",
      bullets: [
        "Check transaction on ploygon scan",
        "Confirm success",
      ],
      imageLabel: "Frame 1618873100",
    },
  ];

  return (
     <section id="plans" className="bg-[#006633] rounded-lg py-12 md:py-16 px-4 sm:px-6 md:px-8 lg:px-16 xl:px-20 2xl:px-24">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <p className="text-white text-[14px] font-medium tracking-wide mb-2">
            All Carbon Plans
          </p>
          <h2 className="text-white text-[24px] sm:text-[28px] md:text-[32px] lg:text-4xl font-bold leading-tight max-w-[998px] mx-auto">
            Your gateway to a sustainable future. Simple, transparent solutions for every climate action
          </h2>
        </div>

        <div className="bg-white border border-[#78BB99] rounded-lg w-full max-w-[998px] mx-auto mb-12 p-1 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-1">
          {plans.map((plan, index) => (
            <button
              key={plan.name}
              onClick={() => setActiveTab(index)}
              className={`
                rounded-md text-[14px] sm:text-[16px] lg:text-[20px] font-medium transition-all duration-200 py-2.5 px-2 h-full whitespace-nowrap
                ${activeTab === index
                  ? 'bg-[#0D924F] text-white'
                  : 'text-gray-400 hover:text-gray-600'
                }
              `}
            >
              {plan.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,450px)_minmax(0,400px)] gap-8 lg:gap-12 justify-center items-start">
          <div className="bg-white border border-gray-300 rounded-xl p-5 sm:p-6 md:px-[40px] md:py-[20px] w-full max-w-[450px] mx-auto lg:mx-0">
            <div className="mb-6">
              <h3 className="text-[14px] font-semibold text-gray-700 mb-4">Access to:</h3>
              <ul className="space-y-4">
                {currentPlan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <span className="relative inline-flex items-center justify-center w-5 h-5 mt-0.5 flex-shrink-0">
                      <span className="absolute w-3 h-3 bg-[#E9F9D2] rounded-full"></span>
                      <svg className="relative w-2 h-2 text-[#7BC216]" viewBox="0 0 12 10" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M1 5L4 8L11 1" strokeLinecap="round" />
                      </svg>
                    </span>
                    <span className="text-[12px] sm:text-[13px] text-gray-700 flex-1 pt-1 break-words">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-8">
              <div className="mb-6">
                <span className="text-2xl sm:text-3xl font-bold text-[#0D924F]">NGN</span>
                {currentPlan.price && (
                  <>
                    <span className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight text-[#0D924F] break-words">
                      {currentPlan.price}
                    </span>
                    <div className="text-sm font-medium text-[#898989]">{currentPlan.tag}</div>
                  </>
                )}
              </div>
              <div className="flex flex-wrap items-center gap-3 sm:gap-4">
                <Link to={currentPlan.link} className="bg-[#0D924F] text-white px-6 sm:px-9 py-3 sm:py-4 md:py-5 rounded-lg text-base sm:text-lg md:text-xl font-medium border border-gray-200 hover:bg-green-700 transition text-center whitespace-nowrap">
                  Choose plan
                </Link>
                <button className="text-[#0D924F] underline text-base sm:text-lg md:text-xl font-medium hover:text-green-700 transition whitespace-nowrap">
                  Learn more
                </button>
              </div>
            </div>
          </div>

          <div className="bg-white border border-gray-400 rounded-xl p-5 sm:p-6 flex items-start gap-4 sm:gap-6 w-full max-w-[400px] mx-auto lg:mx-0 lg:mt-56">
            <div className="relative w-14 h-14 sm:w-16 sm:h-16 flex-shrink-0">
              <div className="absolute inset-0 bg-[#0D924F] rounded-xl"></div>
              <img
                src={CloseCarbon_logo2}
                className="absolute inset-2 w-[calc(100%-16px)] h-[calc(100%-16px)] object-contain"
                alt="CloseCarbon logo"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-lg sm:text-xl md:text-[24px] font-semibold text-gray-800 mb-2 break-words">
                {currentPlan.title}
              </h3>
              <div className="space-y-1">
                {currentPlan.description.map((line, idx) => (
                  <p key={idx} className="text-[12px] text-gray-500 break-words">
                    {line}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Plans